import styled from 'styled-components';
export const List = styled.ul`
display: flex;
flex-wrap: wrap;
gap : 12px;
list-style: none;
`;

export const ListItem = styled.li`
width: 400px;

`